import React from 'react'
import styled from 'styled-components'
import { Box, Container, Flex, theme } from 'pcln-design-system'
import PropTypes from 'prop-types'

const FlexWrapper = styled(Flex)`
  align-content: center;
  justify-content: center;
`

const PrimaryAdBox = styled(Flex)`
  justify-content: center;
  height: 250px;
  width: 100%;
  margin: 0 16px 0 0;
  max-width: 474px;
  min-width: 300px;
  border: 1px solid ${theme.colors.borderGray};
`

const SecondaryAdBox = styled(Flex)`
  justify-content: center;
  height: 250px;
  width: 100%;
  margin: 0 16px 0 0;
  max-width: 474px;
  min-width: 300px;
  border: 1px solid ${theme.colors.borderGray};

  @media only screen and (max-width: 948px) {
    display: none;
  }
`

const StandardAdBox = styled(Flex)`
  height: 250px;
`

const AdContainer = props => (
  <Container>
    <FlexWrapper mx={3}>
      <PrimaryAdBox>
        <Box width={1}>{props.renderPrimaryAd()}</Box>
      </PrimaryAdBox>
      <SecondaryAdBox>
        <Box width={1}>{props.renderSecondaryAd()}</Box>
      </SecondaryAdBox>
      <StandardAdBox width='300px'>
        <Box width={1}>{props.renderStandardAd()}</Box>
      </StandardAdBox>
    </FlexWrapper>
  </Container>
)

AdContainer.displayName = 'AdContainer'

AdContainer.propTypes = {
  renderPrimaryAd: PropTypes.func.isRequired,
  renderSecondaryAd: PropTypes.func.isRequired,
  renderStandardAd: PropTypes.func.isRequired
}

export default AdContainer
